// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileImageFilledSvg from "@fishx/icons-svg/es/asn/FileImageFilled";
import FishxIcon from '../components/FishxIcon';

var FileImageFilled = function FileImageFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileImageFilledSvg
  }));
};

FileImageFilled.displayName = 'FileImageFilled';
export default React.forwardRef(FileImageFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileImageFilled.js
// module id = 2705
// module chunks = 0